import { SubjectListItem, SubjectMap } from '@/project-subject/subject-config/subject-config'
import { MingTing } from '@/project-subject/subject-config/ming-ting/ming-ting'
import { AgentGeneral } from '@/project-subject/subject-config/agent-general/agent-general'

const StorageKey = 'currentProjectSubjectId'

function getCurrentSubject () {
  const storageSubject = Object.values(SubjectMap).find(v => v.id === getStorageSubjectId())
  if (storageSubject) {
    return storageSubject
  }

  const domain = window.location.hostname
  const currentSubject = Object.values(SubjectMap).find((subject) => subject.domains.includes(domain))
  return currentSubject || MingTing
}

export const CURRENT_PROJECT_SUBJECT: SubjectListItem = getCurrentSubject()

export const IS_MING_TING_SUBJECT = CURRENT_PROJECT_SUBJECT.id === MingTing.id

export const IS_AGENT_GENERAL_SUBJECT = CURRENT_PROJECT_SUBJECT.id === AgentGeneral.id

export function setStorageSubjectId (value: string) {
  localStorage.setItem(StorageKey, value)
}

export function getStorageSubjectId () {
  return localStorage.getItem(StorageKey) as string || ''
}
